import React, {Component} from 'react';
import {connect} from 'react-redux';
import {changeStepWaitBlock, showWaitBlock} from "../../../Structure/actions/actionsStructure";
import {login} from "../../../AdminProtectora/actions/actionsAdmin";

let showMetricas = false;

class ChartNumberClics extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        return (
            <div href="#" type="button"
                 className="btn  div-metrica div-metrica-impresiones" aria-label="Left Align">
                {this.props.impresiones}
                <br/>
                <div className="tooltip">
                    impresiones
                    <span className="tooltiptext-left">Impresiones: Veces que se ha mostrado en alguna búsqueda</span>
                </div>
            </div>
        );
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

}

function mapStateToProps(state) {
    return {
        showHead: state.structureControl.showHead,
        showFooter: state.structureControl.showFooter,
        showWaitBlock: state.structureControl.showWaitBlock,
        stepWaitBlock: state.structureControl.stepWaitBlock,
        errorWaitBlock: state.structureControl.errorWaitBlock,
        isLogin: state.access.isLogin
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {changeWaitBlock: showWaitBlock, changeStepWaitBlock, login})(ChartNumberClics)
